export const WIDTH_CONSTRAINTS = [275, 980];
